import {FC} from 'react'
import {useImpersonationSession} from 'src/hooks/useImpersonationSession'

type Props = {
  customerName?: string | null
  className?: string
}

const ImpersonationSessionBadge: FC<Props> = ({customerName, className}) => {
  const {isImpersonating} = useImpersonationSession()

  if (!isImpersonating) return null

  return (
    <div className={`d-flex align-items-center flex-shrink-0 gap-2 ${className ?? ''}`.trim()}>
      <span className='fs-7 fw-semibold text-muted text-nowrap'>Logged in as</span>
      <span className='fs-7 fw-bold text-dark text-truncate' style={{maxWidth: '160px'}}>
        {customerName || 'Customer'}
      </span>
    </div>
  )
}

export default ImpersonationSessionBadge
